import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Constants
import { DEFAULT_FILTER_GROUP } from './constants/filterSection.filterGroups';
import { FILTER_PROPTYPE, SELECTED_FILTER_GROUP_PROPTYPE } from './constants/filterSection.propTypes';

// Components
import FilterGroupToolbar from './organisms/filterGroupToolbar';
import DefaultFilterToolbar from './organisms/defaultFilterToolbar';
import FilterResults from './atoms/filterResults';

// Containers
import withFilterGroups from './containers/withFilterGroups';
var FilterSection = /*#__PURE__*/function (_Component) {
  _inherits(FilterSection, _Component);
  var _super = _createSuper(FilterSection);
  function FilterSection() {
    _classCallCheck(this, FilterSection);
    return _super.apply(this, arguments);
  }
  _createClass(FilterSection, [{
    key: "renderFilterGroupToolbar",
    value: function renderFilterGroupToolbar() {
      return /*#__PURE__*/React.createElement(FilterGroupToolbar, this.props);
    }
  }, {
    key: "renderDefaultToolbar",
    value: function renderDefaultToolbar() {
      return /*#__PURE__*/React.createElement(DefaultFilterToolbar, this.props);
    }
  }, {
    key: "renderTableResultsCount",
    value: function renderTableResultsCount() {
      var _this$props = this.props,
        showOnlyResults = _this$props.showOnlyResults,
        totalResults = _this$props.totalResults,
        renderResultsLabel = _this$props.renderResultsLabel;
      return /*#__PURE__*/React.createElement(FilterResults, {
        showOnlyResults: showOnlyResults,
        resultsCount: totalResults,
        renderResultsLabel: renderResultsLabel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        alwaysRenderDefaultToolBar = _this$props2.alwaysRenderDefaultToolBar,
        appliedFilterGroup = _this$props2.appliedFilterGroup,
        showOnlyResults = _this$props2.showOnlyResults,
        showDefaultToolbar = _this$props2.showDefaultToolbar;
      if (showOnlyResults) {
        return this.renderTableResultsCount();
      }
      if (alwaysRenderDefaultToolBar || showDefaultToolbar && appliedFilterGroup === DEFAULT_FILTER_GROUP) {
        return this.renderDefaultToolbar();
      }
      return this.renderFilterGroupToolbar();
    }
  }]);
  return FilterSection;
}(Component);
FilterSection.propTypes = {
  assetType: PropTypes.string,
  onFilterApply: PropTypes.func,
  filterTypes: PropTypes.arrayOf(FILTER_PROPTYPE),
  selectedFilters: PropTypes.arrayOf(PropTypes.shape({
    filterType: PropTypes.string,
    operator: PropTypes.string,
    values: PropTypes.any
  })),
  moduleType: PropTypes.string,
  appliedFilterGroup: SELECTED_FILTER_GROUP_PROPTYPE,
  defaultFilterTypes: PropTypes.arrayOf(PropTypes.string),
  filterGroups: PropTypes.array,
  showOnlyResults: PropTypes.bool,
  totalResults: PropTypes.number,
  showDefaultToolbar: PropTypes.bool,
  alwaysRenderDefaultToolBar: PropTypes.bool,
  renderResultsLabel: PropTypes.func,
  module: PropTypes.string,
  shouldSetDefaultFilter: PropTypes.bool
};
FilterSection.defaultProps = _objectSpread(_objectSpread({}, FilterGroupToolbar.defaultProps), {}, {
  showDefaultToolbar: true,
  alwaysRenderDefaultToolBar: false,
  module: undefined,
  shouldSetDefaultFilter: false
});
export default withFilterGroups(FilterSection);